export default "__VITE_ASSET__DkOJwxCR__"